export default function () {
  const header = document.getElementById('header');
  const headerSubmenu = document.getElementById('header-bg-submenu');
  const hamburgerMenu = document.querySelector('.hamburger-container');
  const activeClass = 'active';
  const scrolledDownClass = 'scrolled-down';
  const currentClass = 'current';
  const scrollPosition = 10;
  const mouseenterTimeout = 10;
  const mouseleaveTimeout = 100;
  let isOver = false;
  let isActive = false;
  let submenuTimeout = null;

  if (!header) {
    return;
  }

  const menuLinks = header.querySelectorAll('[data-nav-menu-id]');
  const menuLinksWithSubmenu = header.querySelectorAll('[data-nav-menu-id][data-has-submenu="1"]');
  const headerBgSubmenu = document.getElementById('header-bg-submenu');

  // === Liste de tous les conteneurs de contenu de sous-menu ===
  const headerSubmenuContents = header.querySelectorAll('.header-submenu-content');

  let activeMenuId = null;
  let checkInterval = null;

  // === Dernière position X connue du curseur (mise à jour en continu) ===
  let lastMouseX = 0;
  let lastMouseY = 0;

  /**
   * Écoute les mouvements de souris sur tout le document
   * afin de garder en mémoire la dernière position connue du curseur (lastMouseX/lastMouseY).
   * Utilisé par checkCursorPosition() pour savoir où se trouve le curseur sans
   * attendre un nouvel événement mousemove.
   */
  document.addEventListener(
    'mousemove',
    (e) => {
      lastMouseX = e.clientX;
      lastMouseY = e.clientY;
    },
    { passive: true }
  );

  /**
   * Affiche le contenu du sous-menu correspondant à un identifiant donné
   * en ajoutant la classe active sur l'élément ciblé.
   *
   * @param {string} submenuId - Valeur de l'attribut data-nav-submenu-id du sous-menu à afficher.
   */
  function showSubmenuContent(submenuId) {
    const submenu = header.querySelector(`[data-nav-submenu-id="${submenuId}"]`);
    const mainLink = header.querySelector(`[data-nav-menu-id="${submenuId}"]`);
    const links = submenu.querySelectorAll('.header-submenu-content-link');

    if (mainLink) mainLink.classList.add(activeClass);
    if (submenu) submenu.classList.add(activeClass);
    if (links) links.forEach((link) => link.setAttribute('tabindex', '0'));
  }

  /**
   * Masque tous les contenus de sous-menu en retirant la classe active
   * de chaque élément .header-submenu-content.
   */
  function hideSubmenuContent() {
    const links = header.querySelectorAll('.header-submenu-content-link');

    menuLinksWithSubmenu.forEach((link) => link.classList.remove(activeClass));
    headerSubmenuContents.forEach((content) => content.classList.remove(activeClass));

    if (links) links.forEach((link) => link.setAttribute('tabindex', '-1'));
  }

  /**
   * Affiche l'arrière-plan (overlay) associé aux sous-menus
   * en ajoutant la classe active sur #header-bg-submenu.
   */
  function showHeaderBgSubmenu() {
    headerBgSubmenu.classList.add(activeClass);
  }

  /**
   * Masque l'arrière-plan (overlay) associé aux sous-menus
   * en retirant la classe active de #header-bg-submenu.
   */
  function hideHeaderBgSubmenu() {
    headerBgSubmenu.classList.remove(activeClass);
  }

  /**
   * Ferme complètement le sous-menu actif :
   * - masque l'arrière-plan
   * - masque le contenu du sous-menu
   * - réinitialise l'état (isOver, activeMenuId)
   * - arrête la surveillance du curseur
   */
  function closeSubmenu() {
    hideHeaderBgSubmenu();
    hideSubmenuContent();
    isOver = false;
    activeMenuId = null;
    stopCursorWatcher();
  }

  /**
   * Vérifie si un élément donné (généralement celui sous le curseur)
   * se trouve dans une zone autorisée, c'est-à-dire :
   * - à l'intérieur du lien de menu actuellement actif (activeMenuId)
   * - à l'intérieur de l'arrière-plan du sous-menu (#header-bg-submenu)
   * - à l'intérieur d'un contenu de sous-menu (.header-submenu-content)
   *
   * @param {Element|null} element - Élément DOM à tester (peut être null si rien sous le curseur).
   * @returns {boolean} true si l'élément est dans une zone autorisée, false sinon.
   */
  function isCursorOverAllowedZone(element) {
    if (!element) {
      console.log('isCursorOverAllowedZone: aucun élément sous le curseur → hors zone');
      return false;
    }

    const isInZone = Boolean(
      (activeMenuId && element.closest(`[data-nav-menu-id="${activeMenuId}"]`)) ||
      element.closest('#header-bg-submenu') ||
      element.closest('.header-submenu-content')
    );

    console.log(isInZone ? 'isCursorOverAllowedZone: dans la zone ✅' : 'isCursorOverAllowedZone: hors zone ❌');

    return isInZone;
  }

  /**
   * Vérifie la position actuelle du curseur (x, y) et ferme le sous-menu
   * si le curseur ne se trouve plus dans une zone autorisée.
   * Ne fait rien si aucun sous-menu n'est actuellement ouvert (isOver === false).
   *
   * @param {number} x - Coordonnée X du curseur (clientX).
   * @param {number} y - Coordonnée Y du curseur (clientY).
   */
  function checkCursorPosition(x, y) {
    if (!isOver) return;

    const elementUnderCursor = document.elementFromPoint(x, y);

    if (!isCursorOverAllowedZone(elementUnderCursor)) {
      closeSubmenu();
    }
  }

  /**
   * Démarre la surveillance périodique de la position du curseur
   * (toutes les 400ms) afin de détecter quand celui-ci quitte la zone
   * autorisée du sous-menu et de le fermer automatiquement.
   * Arrête d'abord toute surveillance déjà en cours pour éviter les doublons.
   */
  function startCursorWatcher() {
    stopCursorWatcher();
    checkInterval = setInterval(() => {
      checkCursorPosition(lastMouseX, lastMouseY);
    }, 400);
  }

  /**
   * Arrête la surveillance périodique de la position du curseur
   * en supprimant l'intervalle actif (s'il existe).
   */
  function stopCursorWatcher() {
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  }

  function openSubmenu(link, hasWatcher = true) {
    const submenuId = link.getAttribute('data-nav-menu-id');

    const heights = Array.from(headerSubmenuContents).map(getNaturalHeight);
    const maxHeight = Math.max(...heights);

    headerBgSubmenu.style.height = maxHeight + 60 + 'px';

    activeMenuId = submenuId;
    isOver = true;

    hideSubmenuContent();
    showHeaderBgSubmenu();
    showSubmenuContent(submenuId);

    if (hasWatcher) {
      startCursorWatcher();
    }
  }

  menuLinksWithSubmenu.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      openSubmenu(link, true);
    });

    link.addEventListener('focus', () => {
      openSubmenu(link, false);
    });
  });

  function getNaturalHeight(el) {
    // Cas display:none -> on doit le rendre temporairement mesurable
    const wasHidden = getComputedStyle(el).display === 'none';

    if (wasHidden) {
      el.style.visibility = 'hidden';
      el.style.display = 'block';
      el.style.position = 'absolute';
      el.style.maxHeight = 'none';
    }

    const height = el.scrollHeight;

    if (wasHidden) {
      el.style.visibility = '';
      el.style.display = '';
      el.style.position = '';
      el.style.maxHeight = '';
    }

    return height;
  }

  const hideSubmenus = () => {
    Array.from(headerSubmenu.querySelectorAll('.submenu')).forEach((el) => {
      el.style.display = '';
      el.classList.remove(activeClass);
      el.removeEventListener('keydown', onSubmenuKeydown);
    });
  };

  const removeActiveFromLinks = () => {
    Array.from(header.querySelectorAll('[data-submenu].active')).forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
      el.classList.remove(activeClass);
      el.removeEventListener('keydown', onMenuItemKeydown);
    });
  };

  const submenuTransitionend = () => {
    headerSubmenu.style.display = '';
  };

  const removeTransitionendEvent = () => {
    headerSubmenu.removeEventListener('transitionend', submenuTransitionend);
  };

  const submenuMouseout = () => {
    removeActiveFromLinks();
    headerSubmenu.classList.remove(activeClass);

    removeTransitionendEvent();
    headerSubmenu.addEventListener('transitionend', submenuTransitionend, { once: true });

    document.removeEventListener('keydown', onDocumentKeydown);

    isOver = false;
    if (!isActive) {
      header.classList.remove(activeClass);
    }
  };

  // const onDocumentKeydown = (event) => {
  //   // Escape
  //   if (event.keyCode === 27) {
  //     header.querySelector('[data-submenu].active').focus();
  //     submenuMouseout();
  //   }
  // };

  // const onMenuItemKeydown = (event) => {
  //   // Tab
  //   if (event.keyCode === 9) {
  //     if (event.shiftKey) {
  //       submenuMouseout();
  //     } else {
  //       event.preventDefault();
  //       headerSubmenu.querySelector('.submenu.active a').focus();
  //     }
  //   }
  // };

  // const onSubmenuKeydown = (event) => {
  //   const focusableElements = Array.from(header.querySelectorAll('button, a'));
  //   const menuActiveLink = header.querySelector('[data-submenu].active');
  //   const submenuLinks = Array.from(headerSubmenu.querySelectorAll('.submenu.active a'));
  //   const currentLink = event.target;
  //   if (event.keyCode === 9) {
  //     if (event.shiftKey) {
  //       if (submenuLinks[0] === currentLink) {
  //         event.preventDefault();
  //         menuActiveLink.focus();
  //         submenuMouseout();
  //       }
  //     } else {
  //       if (submenuLinks[submenuLinks.length - 1] === currentLink) {
  //         event.preventDefault();
  //         focusableElements[focusableElements.indexOf(menuActiveLink) + 1].focus();
  //         submenuMouseout();
  //       }
  //     }
  //   }
  // };

  // Array.from(header.querySelectorAll('[data-submenu]')).forEach((el) => {
  //   const submenu = headerSubmenu.querySelector(el.dataset.submenu);

  //   const mouseenter = () => {
  //     clearTimeout(submenuTimeout);
  //     updateSubmenuPosition();
  //     removeActiveFromLinks();

  //     el.setAttribute('aria-expanded', 'true');
  //     el.classList.add(activeClass);

  //     removeTransitionendEvent();
  //     headerSubmenu.style.display = 'block';

  //     hideSubmenus();
  //     submenu.style.display = 'block';
  //     submenu.classList.add(activeClass);

  //     isOver = true;

  //     header.classList.add(activeClass);

  //     el.addEventListener('keydown', onMenuItemKeydown);
  //     submenu.addEventListener('keydown', onSubmenuKeydown);
  //     document.addEventListener('keydown', onDocumentKeydown);

  //     setTimeout(() => {
  //       headerSubmenu.classList.add(activeClass);
  //     }, mouseenterTimeout);
  //   };

  //   const mouseleave = () => {
  //     submenuTimeout = setTimeout(submenuMouseout, mouseleaveTimeout);
  //   };

  //   el.addEventListener('mouseenter', mouseenter);
  //   el.addEventListener('mouseleave', mouseleave);

  //   el.addEventListener('keydown', (event) => {
  //     // Enter or space
  //     if (event.keyCode === 13 || event.keyCode === 32) {
  //       event.preventDefault();
  //       if (el.classList.contains(activeClass)) {
  //         mouseleave();
  //       } else {
  //         mouseenter();
  //       }
  //     }
  //   });

  //   el.addEventListener('click', () => {
  //     window.location.href = el.dataset.url;
  //   });
  // });

  let lastScrollTop = 0;

  const onScrolling = function () {
    const st = document.documentElement.scrollTop;

    if (window.scrollY > scrollPosition) {
      if (!isOver) {
        header.classList.add(activeClass);
      }
      header.classList.add(scrolledDownClass);
      headerSubmenu.classList.add(scrolledDownClass);
      hamburgerMenu.classList.add(scrolledDownClass);
      isActive = true;

      if (st > lastScrollTop) {
        header.classList.remove('desktop-nav-expanded');
      } else if (st < lastScrollTop) {
        header.classList.add('desktop-nav-expanded');
      }
    } else {
      if (!isOver) {
        header.classList.remove(activeClass);
      }
      header.classList.remove(scrolledDownClass);
      headerSubmenu.classList.remove(scrolledDownClass);
      // hideHeaderBgSubmenu();
      // hideSubmenuContent();
      hamburgerMenu.classList.remove(scrolledDownClass);
      isActive = false;
    }

    lastScrollTop = st <= 0 ? 0 : st;
  };

  document.addEventListener('scroll', onScrolling);
  onScrolling();

  // const currentUrl = window.location.href.replace(window.location.hash, '');
  // const currentLink = document.querySelector('.header-link[href="' + currentUrl + '"]');
  // const currentLinkWithSubmenu = headerSubmenu.querySelector('a[href="' + currentUrl + '"]');
  // if (currentLinkWithSubmenu) {
  //   currentLinkWithSubmenu.classList.add(currentClass);
  //   const currentSubmenuId = currentLinkWithSubmenu.closest('.submenu').getAttribute('id');
  //   const currentSubmenu = header.querySelector('[data-submenu="#' + currentSubmenuId + '"]');
  //   if (currentSubmenu) {
  //     currentSubmenu.classList.add(currentClass);
  //   }
  // } else if (currentLink) {
  //   currentLink.classList.add(currentClass);
  // }

  document.querySelectorAll('.js-site-selector').forEach((el) => {
    el.addEventListener('change', (ev) => (window.location = ev.target.value));
  });

  // const updateSubmenuPosition = () => {
  //   const submenusWithoutImg = document.querySelectorAll('.submenu-without-img');

  //   submenusWithoutImg.forEach(menu => {
  //     let id = menu.getAttribute('id');
  //     let button = document.querySelector(`[data-submenu="#${id}"]`);
  //     let rect = button.getBoundingClientRect();
  //     let position = window.innerWidth - rect.x - rect.width;
  //     let ulElement = menu.querySelector('ul');

  //     console.log("x", rect.x);

  //     ulElement.style.right = `${position}px`;
  //   });
  // };

  // updateSubmenuPosition();

  const highlightCurrentMenuItem = () => {
    const urlPieces = [location.protocol, '//', location.host, location.pathname];
    let currentUrl = urlPieces.join('');
    const breadcrumbLinks = document.querySelectorAll('.site-breadcrumb a');
    const lastBreadcrumbLink = breadcrumbLinks && breadcrumbLinks.length > 0 ? breadcrumbLinks[breadcrumbLinks.length-1] : null;
    header.querySelectorAll('.main-navigation > li').forEach((el) => {
      el.querySelectorAll('a').forEach((link) => {
        if (
          currentUrl.includes(link.href) ||
          lastBreadcrumbLink?.href?.includes(link.href) ||
          link.href.includes(lastBreadcrumbLink?.href)
        ) {
          el.querySelector('&>button')?.classList?.add('current-menu-item');
        }
        if (link.href === currentUrl) {
          link.classList.add('current-link');
        }
      });
    });
  };

  highlightCurrentMenuItem();
}
